<template>
  <v-container fluid>
    <v-card>
      <a-vuex-data-table :headers="headers">
        <template #header>
          <a-data-table-header-filters>
            <a-data-table-filter v-model.trim="numero" label="N°" />
            <a-data-table-select-filter
              v-model="tribunal"
              :items="listeTribunaux"
              label="Tribunaux"
            />
            <a-data-table-filter v-model.trim="nom" label="Dénomination" />
            <a-data-table-filter v-model.trim="codePostal" label="Code postal" />
            <a-data-table-filter v-model.trim="commune" label="Commune" />
            <a-data-table-filter v-model.trim="adresse" label="Adresse" />
            <a-data-table-select-filter
              v-model="etats"
              :items="etatsAssociation"
              label="Etat"
            />
            <a-data-table-empty-filter />
          </a-data-table-header-filters>
        </template>
        <template #item.etat="{ item }">
          <span>{{ item.etat | etatassociation }}</span>
        </template>

        <template #item.actions="{ item }">
          <span class="d-flex justify-center align-center">
            <a-tooltip-icon-button
              icon="mdi-eye-circle"
              tooltip="Consulter l'association"
              color="primary"
              @click="toDetailAssociation(item)"
              data-testid="consulter-association"
            />
          </span>
        </template>
      </a-vuex-data-table>
    </v-card>
  </v-container>
</template>

<script>
import makeVuexTable from "@/mixins/makeVuexTable";
import { etatAssociationSelectItems } from "@/filters/etatassociation";
import { mapGetters } from "vuex";
import { toDetailAssociation } from "@/routes/associations";

export default {
  mixins: [
    makeVuexTable({
      store: "tables/associations",
      provide: true,
      fields: {
        numero: "numero",
        nom: "nom",
        etats: "etats",
        commune: "commune",
        codePostal: "codePostal",
        adresse: "adresse",
        volume: "volume",
        folio: "folio",
        tribunal: "tribunal",
      },
    }),
  ],

  data() {
    return {
      headers: [
        { text: "N°", value: "numero", sortable: false },
        { text: "Tribunaux", value: "tribunal" },
        { text: "Dénomination", value: "nom" },
        { text: "Code postal", value: "codePostal" },
        { text: "Commune", value: "libelleCommune" },
        { text: "Adresse", value: "adresse" },
        { text: "Etat", value: "etat" },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
          width: "100px",
          align: "center",
        },
      ],
    };
  },

  methods: {
    toDetailAssociation(item) {
      this.$router.push(toDetailAssociation(item.numero));
    },
  },

  computed: {
    ...mapGetters({
      tribunaux: "fichiers/tribunaux",
    }),
    listeTribunaux() {
      return [...this.tribunaux]
        .map(t => ({ value: t.id, text: t.libelle }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    etatsAssociation() {
      return etatAssociationSelectItems();
    },
  },
};
</script>
